import { type Olympus } from '@owner/olympus-client'
import {
  PhBookOpen,
  PhBriefcase,
  PhCalendarBlank,
  PhCar,
  PhClock,
  PhConfetti,
  PhCreditCard,
  PhCrown,
  PhCurrencyCircleDollar,
  PhDesktop,
  PhForkKnife,
  PhGift,
  PhGlobe,
  PhHandbag,
  PhHeart,
  PhHouse,
  PhInfo,
  PhLeaf,
  PhMapPin,
  PhMoney,
  PhNewspaper,
  PhNotepad,
  PhPaperPlaneTilt,
  PhPhone,
  PhPizza,
  PhStar,
  PhTote,
  PhTruck,
  PhUsersFour,
} from 'phosphor-vue/dist/phosphor-vue.esm'
import type Vue from 'vue'

// Casing varies because some of these are originally from `featureIcons`
export const announcementIcons: Record<Olympus.Funnel.BannerIcon, Vue> = {
  BookOpen: PhBookOpen,
  CalendarBlank: PhCalendarBlank,
  Confetti: PhConfetti,
  CreditCard: PhCreditCard,
  Crown: PhCrown,
  CurrencyCircleDollar: PhCurrencyCircleDollar,
  Desktop: PhDesktop,
  ForkKnife: PhForkKnife,
  Gift: PhGift,
  Info: PhInfo,
  Money: PhMoney,
  Newspaper: PhNewspaper,
  Notepad: PhNotepad,
  PaperPlaneTilt: PhPaperPlaneTilt,
  Phone: PhPhone,
  Pizza: PhPizza,
  car: PhCar,
  card: PhCreditCard,
  cart: PhHandbag,
  delivery: PhTruck,
  dish: PhForkKnife,
  domains: PhGlobe,
  heart: PhHeart,
  leaf: PhLeaf,
  overview: PhHouse,
  phone: PhPhone,
  pin: PhMapPin,
  star: PhStar,
  story: PhBookOpen,
  team: PhUsersFour,
  time: PhClock,
  tote: PhTote,
  work: PhBriefcase,
}
